export const createAudienceExportReportFileName = (params: {
  audienceName: string;
  date?: Date;
}) => {
  const { audienceName, date = new Date() } = params;
  const audienceNameString = audienceName
    .replace(/[/\\:*?"<>|]/g, '_')
    .replace(/\s+/g, '_')
    .toLowerCase();
  const dateString = `${(date.getMonth() + 1).toString().padStart(2, '0')}_${date
    .getDate()
    .toString()
    .padStart(2, '0')}_${date.getFullYear()}`;
  return `${audienceNameString}_opened_${dateString}.csv`;
};
